import React from "react";
import "./sign-up.page.scoped.scss";
import { AuthProvider } from "../../store";
import { SignUpLayout } from "../../layouts/signup/sign-up.layout";
import { NormalSignUpComponent } from "../../components/normal-sign-up/normal-sign-up.component";

const SignUpPage = (props: any) => {
  const token = props.match.params.id;
  const tenantId = props.match.params.tenantId;
  return (
    <SignUpLayout>
      <AuthProvider>
        <NormalSignUpComponent token={token} tenantId={tenantId} />
      </AuthProvider>
    </SignUpLayout>
  );
};

export default SignUpPage;
